import { potionArt } from '../../utils/arena/alchemist';

// Extract local pigment contrast from the actual plate at its original size.
// Subtracting a gently blurred copy removes broad lighting differences without
// inventing, rotating or shifting any of the crayon marks. The alpha floor keeps
// even the dark liquid lit while its existing grain controls the emitted light.
export default function PotionGrainMask({ id, potion }) {
  return (
    <>
      <filter id={`${id}-pigment`} x="0" y="0" width="100%" height="100%" colorInterpolationFilters="sRGB">
        <feColorMatrix type="saturate" values="0" result="pigment" />
        <feGaussianBlur in="pigment" stdDeviation="4" result="localTone" />
        <feComposite in="pigment" in2="localTone" operator="arithmetic" k2="2.6" k3="-2.6" k4=".65" result="grain" />
        <feColorMatrix in="grain" type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0.8 0 0 0 0.3" />
      </filter>
      <mask id={id} maskUnits="userSpaceOnUse" x="0" y="0" width="1024" height="1024" style={{ maskType: 'alpha' }}>
        <image data-testid="potion-grain-source" href={potionArt(potion)} x="0" y="0" width="1024" height="1024"
          preserveAspectRatio="none" filter={`url(#${id}-pigment)`} />
      </mask>
    </>
  );
}
